import { CALL_API } from 'redux-api-middleware'

const key = 'Gyuklj#$#4asdGa#19'

export default function() {
  return function(next) {
    return function(action) {
      const callApi = action[CALL_API]

      // Check if this action is a redux-api-middleware action.
      if (callApi) {
        // Inject the Authorization header from localStorage.
        callApi.headers = Object.assign({}, callApi.headers, {
          'authorization': key
        })
      }

      // Pass the FSA to the next action.
      return next(action)
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/api_auth_injector.js